// extracted by mini-css-extract-plugin
module.exports = {"addPhone":"NewPhone_addPhone_n9zqj","deleteBtn":"NewPhone_deleteBtn_1sf3T","deleteIcon":"NewPhone_deleteIcon_sTHUn"};